import { formatDate } from "@angular/common";

export class TransactionData {
    public RequestID!: string;
    public MessageID!: string;
    public RelatesToMessageID!: string;
    public PharmacyName!: String;
    public PharmacyNCPDPID!: String;
    public MessageType!: String;
    public Species!: String;
    public ResponseStatus!: String;
    public PatientLastName!: String;
    public PatientDOB!: Date;
    public RequestDate!: Date;
    public Initiator!:String;
}
export class Pagination{
  public PageNumber!:number;
  public PageSize!:number;
  public TotalItems!:number;
  public TotalPages!:number;
}
export class TransactionGridData{
    public TotalNumberOfRecords!: number;
    public transactionData!: TransactionData[];
    public pagination: Pagination = new Pagination;

  }
  export class TransactionGridDataMapper{
    private transactionDataMapper =new TransactionDataMapper();
    private paginationMapper =new TransactionDataPaginationMapper();
    mapToModel(json: any): TransactionGridData {
      let transactionGridData=new TransactionGridData();
      
      if (json) {
        transactionGridData = new TransactionGridData();
        transactionGridData.transactionData = json.ResponseData.map((item:any)=>this.transactionDataMapper.mapToModel(item));
        if(json.Pagination!=null)
        {
        transactionGridData.pagination.PageNumber=json.Pagination.PageNumber;
        transactionGridData.pagination.PageSize=json.Pagination.PageSize;
        transactionGridData.pagination.TotalItems=json.Pagination.TotalItems;
        transactionGridData.pagination.TotalPages=json.Pagination.TotalPages;
        }
      }
      return transactionGridData;
    }
  }
let transactionData: TransactionData;
export class TransactionDataMapper {
    mapToModel(json: any): TransactionData {
        
        if (json) {
            transactionData = new TransactionData();
            transactionData.RequestID = json.RequestID;
            transactionData.MessageID = json.MessageID;
            transactionData.RelatesToMessageID = json.RelatesToMessageID;
            transactionData.PharmacyName = json.PharmacyName;
            transactionData.PharmacyNCPDPID = json.PharmacyNcpdpid;
            transactionData.ResponseStatus = json.ResponseStatus;
            transactionData.Species = json.IsPet=="False" || json.IsPet=="false"?"Human":"Pet";
            transactionData.PatientLastName = json.PatientLastName;
            transactionData.PatientDOB = json.PatientDOB;
            transactionData.RequestDate = json.RequestDate;
            transactionData.MessageType = json.MessageType;
            transactionData.Initiator=json.Initiator;
        }
        return transactionData;
    }
}
let pagination: Pagination;
export class TransactionDataPaginationMapper {
  mapToModel(json: any): Pagination {
      
      if (json) {
         pagination = new Pagination();
         pagination.PageNumber = json.PageNumber;
         pagination.PageSize = json.PageSize;
         pagination.TotalItems = json.TotalItems;
         pagination.TotalPages = json.TotalPages;
      }
      return pagination;
  }
}